import React, { useEffect } from "react";

export default function LoginPage(props) {
	const loginUrl =
		process.env.REACT_APP_CUDY_LOGIN_URL +
		"?from=" +
		props.location.state.from;
	useEffect(() => {
		window.location.replace(loginUrl);
	}, []);
	return <div>Redirecting to Cudy login page...</div>;
}
